import { Bookmark } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getFavorites } from '../api.js'
import BackButton from '../components/BackButton.jsx'
import EmptyState from '../components/EmptyState.jsx'
import ErrorState from '../components/ErrorState.jsx'
import LoadingState from '../components/LoadingState.jsx'
import RepoCard from '../components/RepoCard.jsx'
import { NOINDEX_ROBOTS, setPageMetadata } from '../page-metadata.js'

function FavoritesPage() {
  const location = useLocation()
  const backLabel = location.state?.backLabel || '返回首页'
  const fallbackPath = location.state?.fallbackPath || '/'
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => setPageMetadata({
    title: '我的收藏 - 青途 AI',
    description: '青途 AI 我的收藏。',
    robots: NOINDEX_ROBOTS,
  }), [])

  const load = useCallback((signal) => {
    setLoading(true)
    setError('')
    getFavorites(signal)
      .then((data) => setItems(data.items))
      .catch((requestError) => {
        if (requestError.name !== 'AbortError') setError(requestError.message)
      })
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    const controller = new AbortController()
    load(controller.signal)
    return () => controller.abort()
  }, [load])

  return (
    <div className="page-container">
      <BackButton fallbackPath={fallbackPath}>{backLabel}</BackButton>

      <section className="page-heading compact-heading">
        <div>
          <span className="eyebrow">YOUR COLLECTION</span>
          <h1>我的收藏</h1>
          <p>把值得继续研究的项目放在一个安静、可回看的清单里。</p>
        </div>
      </section>

      {loading && <LoadingState label="正在读取收藏" />}
      {!loading && error && <ErrorState message={error} onRetry={() => load()} />}
      {!loading && !error && items.length === 0 && (
        <EmptyState
          icon={<Bookmark size={28} />}
          title="还没有收藏项目"
          message="在每日榜单或项目详情页点击收藏按钮即可加入。"
        />
      )}
      {!loading && !error && items.length > 0 && (
        <div className="repo-list">
          {items.map((repo) => (
            <RepoCard
              key={repo.id}
              repo={repo}
              onFavoriteChange={(repoId, isFavorited) => {
                if (!isFavorited) {
                  setItems((current) => current.filter((item) => item.id !== repoId))
                }
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default FavoritesPage
